import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './loading.module.css';
import { faArrowsRotate } from '@awesome.me/kit-012d1b9af0/icons/classic/regular';

export default function Loading({ text }: { text: string }) {
	return (
		<div className={styles.loading}>
			<FontAwesomeIcon icon={faArrowsRotate} size='lg' spin /> {text}
		</div>
	);
}
